import RoleCard from "../RoleCard";
import { TeamRole } from "../../types";
import { PaginationControls, Shimmer } from "../../../../shared/ui";

const RolesLoadingShimmer = () => {
  return (
    <div className="mt-6 grid gap-4 xl:grid-cols-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="rounded-[20px] border border-[#E1E6FF] bg-white p-5"
        >
          <div className="space-y-3">
            <Shimmer className="h-6 w-[160px]" />
            <Shimmer className="h-4 w-full" />
            <Shimmer className="h-4 w-[85%]" />
          </div>
          <div className="mt-6 space-y-2">
            <Shimmer className="h-9 w-full rounded-[12px]" />
            <Shimmer className="h-9 w-full rounded-[12px]" />
          </div>
          <div className="mt-6 flex items-center gap-2">
            <Shimmer className="h-9 w-9 rounded-full" />
            <Shimmer className="h-9 w-9 rounded-full" />
            <Shimmer className="h-9 w-9 rounded-full" />
          </div>
        </div>
      ))}
    </div>
  );
};

type RolesPermissionsGridProps = {
  isLoading: boolean;
  error: string | null;
  filteredRolesCount: number;
  pagedRoles: TeamRole[];
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onEditRole: (role: TeamRole) => void;
  onAddMembers: (role: TeamRole) => void;
  onDeleteRole: (role: TeamRole) => void;
  onOpenDetails: (role: TeamRole) => void;
};

const RolesPermissionsGrid = ({
  isLoading,
  error,
  filteredRolesCount,
  pagedRoles,
  currentPage,
  totalPages,
  onPageChange,
  onEditRole,
  onAddMembers,
  onDeleteRole,
  onOpenDetails,
}: RolesPermissionsGridProps) => {
  return (
    <>
      {isLoading ? (
        <RolesLoadingShimmer />
      ) : error ? (
        <div className="mt-6 rounded-xl border border-dashed border-[#F1D6D6] p-8 text-center text-[#C24E4E]">
          {error}
        </div>
      ) : filteredRolesCount === 0 ? (
        <div className="mt-6 rounded-xl border border-dashed border-[#D7DCF0] p-8 text-center text-[#6B6F8A]">
          No roles available yet.
        </div>
      ) : (
        <div className="mt-6 grid gap-4 xl:grid-cols-3">
          {pagedRoles.map((role) => (
            <RoleCard
              key={role.id}
              role={role}
              onEditRole={onEditRole}
              onAddMembers={onAddMembers}
              onDeleteRole={onDeleteRole}
              onOpenDetails={onOpenDetails}
            />
          ))}
        </div>
      )}

      {!isLoading && !error && filteredRolesCount > 0 ? (
        <PaginationControls
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
          className="mt-8 flex items-center gap-2"
        />
      ) : null}
    </>
  );
};

export default RolesPermissionsGrid;
